/* Free Gift Selector — cart drawer variant picker (Founding Member promotion).
   Uses event delegation so it keeps working after every AJAX re-render of the
   drawer (add-to-cart, quantity change, gift swap) without re-binding. */
(function () {
  'use strict';

  var busy = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-gift__option');
    if (!btn) return;
    if (btn.disabled || busy) return;
    if (btn.classList.contains('is-selected')) return; // already the chosen gift
    selectGift(btn);
  }, true);

  function selectGift(clicked) {
    busy = true;
    var variantId = clicked.dataset.giftVariantId;
    var giftHandle = clicked.dataset.giftHandle;

    // Optimistic UI
    var container = clicked.closest('.cart-gift');
    if (container) {
      container.querySelectorAll('.cart-gift__option').forEach(function (b) {
        b.classList.remove('is-selected');
      });
    }
    clicked.classList.add('is-selected');
    clicked.classList.add('is-loading');

    // Remove any existing gift variant, then add the chosen one (one per order)
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if (item.handle === giftHandle) updates[item.key] = 0;
        });
        if (Object.keys(updates).length > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () { return addGift(variantId); });
        }
        return addGift(variantId);
      })
      .then(function (r) {
        if (r && !r.ok) {
          return r.json().then(function (err) {
            throw new Error(err.description || err.message || 'Could not add gift');
          });
        }
        return refreshDrawer();
      })
      .catch(function (err) {
        clicked.classList.remove('is-selected', 'is-loading');
        if (typeof window.GYMSKYNS_showCartToast === 'function') {
          window.GYMSKYNS_showCartToast(err.message || 'Could not add gift');
        }
      })
      .then(function () {
        busy = false;
        updateCartCount();
      });
  }

  function addGift(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    });
  }

  function refreshDrawer() {
    // Preferred: full section re-render (shared helper from gymskyns-quick-view.js)
    if (typeof window.GYMSKYNS_refreshCartDrawer === 'function') {
      return window.GYMSKYNS_refreshCartDrawer();
    }
    // Fallback: swap just the items list
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('#CartDrawer');
        var oldDrawer = document.querySelector('#CartDrawer');
        if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
      });
  }

  function updateCartCount() {
    if (typeof window.GYMSKYNS_updateCartCount === 'function') {
      window.GYMSKYNS_updateCartCount();
    }
  }

  /* Minimum-amount condition enforcement: if the cart drops below the
     threshold while a gift is in it, Liquid flags the block with
     data-remove-gift — remove the gift and re-render. */
  var removing = false;

  function enforceGiftCondition() {
    var el = document.querySelector('#cartGiftSelector[data-remove-gift]');
    if (!el || removing) return;
    removing = true;
    var handle = el.getAttribute('data-remove-gift');
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if (item.handle === handle) updates[item.key] = 0;
        });
        if (Object.keys(updates).length === 0) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(refreshDrawer).then(updateCartCount);
      })
      .catch(function () {})
      .then(function () { removing = false; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    enforceGiftCondition();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(enforceGiftCondition).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
